import { Directive, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";
import { NotEqualValidator } from "../validator/not-equal.validator";

@Directive({
  selector: '[notEqual][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: NotEqualDirective, multi: true }]
})

export class NotEqualDirective implements Validator {
  @Input('notEqual') compareToValue: string = '';

  private valFn = NotEqualValidator;
  validate(control: AbstractControl): { [key: string]: any } {
    return this.valFn(this.compareToValue)(control);
  }
}
